export enum MinimumWageScopeConfig {
  ALL_PROJECTS_IN_JURISDICTION = 'All Projects In Jurisdiction',
  ALL_LOCATIONS_IN_PROJECT = 'All Locations In Project',
  SPECIFIC_LOCATION_IN_PROJECT = 'Specific Location In Project',
}
